import { Component, OnInit, OnDestroy } from '@angular/core';

import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'progress-indicator',
    templateUrl: './progress-indicator.component.html',
    styleUrls: ['./progress-indicator.component.scss']
})
export class ProgressIndicatorComponent implements OnInit, OnDestroy {

    constructor(private progressIndicatorService: ProgressIndicatorService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    get progress(): boolean {
        return this.progressIndicatorService.progress;
    }

    set progress(value: boolean) {
        this.progressIndicatorService.progress = value;
    }
}
